module.exports = __webpack_public_path__ + "static/media/Hover5.d7c7643a.svg";